import { Box, Text, Table, Divider } from "@mantine/core";

interface StainEntry {
  stainName: string;
  stainCode: string;
  result: string;
  specimenLabel?: string;
  cptCode?: string;
}

interface StainTableSectionProps {
  label: string;
  ihcResults: StainEntry[] | null;
  specialStainResults: StainEntry[] | null;
  tableColumns?: string[];
}

export function StainTableSection({
  label,
  ihcResults,
  specialStainResults,
  tableColumns = ["Stain", "CPT Code", "Result"],
}: StainTableSectionProps) {
  const allStains = [
    ...(ihcResults || []).map((r) => ({ ...r, type: "IHC" })),
    ...(specialStainResults || []).map((r) => ({ ...r, type: "Special" })),
  ];

  if (allStains.length === 0) return null;

  return (
    <Box mt={16} style={{ breakInside: "avoid", pageBreakInside: "avoid" }}>
      <Divider mb={10} />
      <Text fw={700} size="sm" mb={8} style={{ letterSpacing: 1 }}>
        {label}
      </Text>
      <Table fz="xs" withTableBorder withColumnBorders>
        <Table.Thead>
          <Table.Tr>
            {tableColumns.map((col) => (
              <Table.Th key={col}>{col}</Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {allStains.map((stain, i) => (
            <Table.Tr key={i}>
              <Table.Td>
                {stain.stainName} ({stain.type})
              </Table.Td>
              {tableColumns.includes("CPT Code") && (
                <Table.Td>{stain.cptCode || stain.stainCode}</Table.Td>
              )}
              {tableColumns.includes("Result") && (
                <Table.Td>{stain.result || "Pending"}</Table.Td>
              )}
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Box>
  );
}
